import { render, staticRenderFns } from "./AutomatorDocs.vue?vue&type=template&id=192f8680&scoped=true"
import script from "./AutomatorDocs.vue?vue&type=script&lang=js"
export * from "./AutomatorDocs.vue?vue&type=script&lang=js"
import style0 from "./AutomatorDocs.vue?vue&type=style&index=0&id=192f8680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192f8680",
  null
  
)

export default component.exports